import React from "react";
import Render from "@gqlapp/theme";
import template from "./view.html.twig";
import { sharedPartials } from "@modules/layout/partials";
import { safeQuery, fetchMenu, fetchList } from "@lib/content/fetch";
import { cleanPath, imageSrc, toTeasers } from "@lib/content/normalize";
import PHOTO_QUERY from "@modules/photo/graphql/PhotoQuery.graphql";
import PHOTOS_QUERY from "@modules/photo/graphql/PhotosQuery.graphql";

const EMPTY = { found: false, title: '', image: '', media: [], categories: [] };

export default function ViewContainer(props: any){
	const { photoData } = props;
	return <>
		<Render {...{ template, context: { partials: { ...sharedPartials }, ...EMPTY, ...(photoData || {}) } }} />
	</>;
}

ViewContainer.getInitialProps = async (ctx: any) => {
	const { apolloClient } = ctx || {};
	const path = cleanPath(ctx?.path);

	try {
		const [data, more, categories] = await Promise.all([
			safeQuery(apolloClient, PHOTO_QUERY, { path }),
			fetchList(apolloClient, PHOTOS_QUERY, { page: 1, pageSize: 6 }),
			fetchMenu(apolloClient, 'gallery'),
		]);
		const res = data?.res;
		return { photoData: { found: !!res, title: res?.title || ctx?.graphqlRoute?.title || '', image: imageSrc(res?.image, 'full'), media: toTeasers(more.edges), categories } };
	} catch (e) {
		debug(e);
		return { photoData: { ...EMPTY, title: ctx?.graphqlRoute?.title || '' } };
	}
};
